<template>
  <div>
    <div class="ml-4 mr-4">
      <div class="is-flex is-justify-content-center" id="filtersContainer" v-click-outside="forceClose_closeDropdownBox">
        <!--  TOGGLE MAP VIEW -->
        <ToggleMapViewForBookingResults :type="'car'" class="mr-1" v-if="sameDropoff" />

        <!--  ALL FILTERS MODAL BOX -->
        <div ref="mainFilterButton" id="mainFilterButton">
          <ShowModalButton
              :rounded="true"
              :label="filterButtonLabel"
              :type="'is-info is-outlined'"
              :size="'is-small'"
              :icon-left="'filter-variant-plus'"
              :close-modal="closeCustomModal"
              data-test="modal_filters_button"
              :key="forceKey"
          >
            <template #modalContent>
              <div id="modalFilters">
                <h2 class="is-size-4 gant-text has-text-centered">{{ filterButtonLabel }}</h2>
                <div class="is-flex is-justify-content-center pb-3">
                  <ResetAllFiltersButton v-if="numOfFiltersUsed > 2" @clicked="forceClose_closeDropdownBox(); $emit('clearFilters')"/>
                  <ResetAllFiltersButton v-if="numOfFiltersUsed > 2" @clicked="forceClose_closeDropdownBox(); $emit('clearFilters'); forceClose_closeModal();" class="ml-3" :label="'Reset and Close'"/>
                </div>
                <hr class="mt-1 mb-5">

                <div class="columns ml-6 mr-6">
                  <!-- SORT BY -->
                  <div class="column is-flex">
                    <FieldsetBox :box-style="value.sortOrder ? highlightedBoxStyle : ''">
                      <template #header>
                        <span class="textOnly" :class="value.sortOrder ? highlightedLabelClass : 'has-text-grey-light'">Sort by</span>
                      </template>
                      <template #content>
                        <SortButtons data-test="modal_sort_filter_list" :value="value.sortOrder" :options="sortOptions" @input="handleSortInput" />
                      </template>
                    </FieldsetBox>
                  </div>
                  <!-- PRICE -->
                  <div class="column is-flex">
                    <FieldsetBox :box-style="highlights.price ? highlightedBoxStyle : ''">
                      <template #header>
                        <span class="textOnly" :class="highlights.price ? highlightedLabelClass : 'has-text-grey-light'">Price</span>
                      </template>
                      <template #content>
                        <b-field v-if="priceRange.length"
                                 :label="'Price: $'+ value.maxPrice[0] + '-$' + value.maxPrice[1]"
                                 style="width: 180px">
                          <HistogramSliderW2 v-model="priceRange" :width="180" :expo="true" :height="25" :sliderData="sliderData" @input="priceFilterUpdate"></HistogramSliderW2>
                        </b-field>
                      </template>
                    </FieldsetBox>
                  </div>
                  <!-- POLICY -->
                  <div class="column is-flex">
                    <FieldsetBox :box-style="value.minPolicy ? highlightedBoxStyle : ''">
                      <template #header>
                        <span class="textOnly" :class="value.minPolicy ? highlightedLabelClass : 'has-text-grey-light'">Policy</span>
                      </template>
                      <template #content>
                        <PolicySelectionCheckboxes data-test="modal_policy_filter_list" :value="value.minPolicy" :availablePolicies="availablePolicies" @input="handlePolicyInput"></PolicySelectionCheckboxes>
                      </template>
                    </FieldsetBox>
                  </div>
                </div>

                <div class="columns ml-6 mr-6">
                  <!-- CHAIN -->
                  <div class="column is-flex">
                    <FieldsetBox :box-style="value.selectedProviders.length > 0 ? highlightedBoxStyle : ''">
                      <template #header>
                        <span class="textOnly" :class="value.selectedProviders.length > 0 ? highlightedLabelClass : 'has-text-grey-light'">Chain</span>
                      </template>
                      <template #content>
                        <ChainSelection
                             data-test="modal_chains_filter_list"
                            :selectedChains="value.selectedProviders"
                            :availableChains="availableChains"
                            :preferredChains="preferredChains"
                            :filteredChains="filteredChains"
                            :vendorsList="vendorsCars"
                            @input="handleChainInput" />
                      </template>
                    </FieldsetBox>
                  </div>
                  <!-- VEHICLE TYPE -->
                  <div class="column is-flex">
                    <FieldsetBox :box-style="value.selectedTypes.length > 0 ? highlightedBoxStyle : ''">
                      <template #header>
                        <span class="textOnly" :class="value.selectedTypes.length > 0 ? highlightedLabelClass : 'has-text-grey-light'">Vehicle Type</span>
                      </template>
                      <template #content>
                        <ChainSelection
                            data-test="modal_type_filter_list"
                            :selectedChains="value.selectedTypes"
                            :availableChains="availableTypes"
                            :filteredChains="filteredTypes"
                            @input="handleTypeInput" />
                      </template>
                    </FieldsetBox>
                  </div>
                  <!-- VEHICLE SIZE -->
                  <div class="column is-flex">
                    <FieldsetBox :box-style="value.selectedCategories.length > 0 ? highlightedBoxStyle : ''">
                      <template #header>
                        <span class="textOnly" :class="value.selectedCategories.length > 0 ? highlightedLabelClass : 'has-text-grey-light'">Vehicle Size</span>
                      </template>
                      <template #content>
                        <ChainSelection
                            data-test="modal_size_filter_list"
                            :selectedChains="value.selectedCategories"
                            :availableChains="availableCategories"
                            :filteredChains="filteredCategories"
                            @input="handleCategoryInput" />
                      </template>
                    </FieldsetBox>
                  </div>
                </div>

                <div class="is-flex is-justify-content-center pt-5">
                  <b-button
                      type="is-primary"
                      size="is-small"
                      label="Apply Filters"
                      @click="forceClose_closeModal"
                      class="mr-1"
                  >
                  </b-button>
                  <b-button
                      type="is-outlined"
                      size="is-small"
                      label="Close"
                      @click="forceClose_closeModal"
                      class="mr-1"
                  >
                  </b-button>
                </div>
                <div class="is-flex is-justify-content-center pb-3">
                  <ResetAllFiltersButton v-if="numOfFiltersUsed > 2" @clicked="forceClose_closeDropdownBox(); $emit('clearFilters')" />
                  <ResetAllFiltersButton v-if="numOfFiltersUsed > 2" @clicked="forceClose_closeDropdownBox(); $emit('clearFilters'); forceClose_closeModal();" class="ml-3" :label="'Reset and Close'"/>
                </div>
              </div>
            </template>
          </ShowModalButton>
        </div>

        <!--  THE REST of the FILTERS (Custom Dropdowns) -->
        <div class="flexedFilters sortingFiltersContainer scrollContent is-flex">
          <!-- SORT BY -->
          <section>
            <div ref="sortOrder">
              <b-button
                  data-test="sort_filter_button"
                  rounded
                  size="is-small"
                  :icon-right="!value.sortOrder ? 'menu-down' : null"
                  :type="value.sortOrder ? 'is-info is-light' : 'is-outlined'"
                  @click="$popper.togglePopper($refs.sortOrder, $refs.sortButtons)"
              >
                Sort by{{ value.sortOrder ? ':' : '' }} <span class="has-text-weight-bold">{{ value.sortOrder }}</span>
                <ResetFilterButton v-if="value.sortOrder" @reset="resetFilter('sortOrder')" />
              </b-button>
            </div>
            <div ref="sortButtons" class="popper-popup filterBox">
              <FilterBoxHeader filter-name="Sort by" @closeFilterBox="forceClose_closeDropdownBox"/>
              <SortButtons data-test="sort_filter_list" :value="value.sortOrder" :options="sortOptions" @input="handleSortInput" />
            </div>
          </section>
          <!-- PRICE -->
          <section>
            <div ref="maxPrice">
              <b-button
                  data-test="price_filter_button"
                  rounded
                  size="is-small"
                  :icon-right="!highlights.price ? 'menu-down' : null"
                  :type="highlights.price ? 'is-info is-light' : 'is-outlined'"
                  @click="$popper.togglePopper($refs.maxPrice, $refs.priceCBs)"
              >
                Price{{ highlights.price ? ':' : '' }} <span class="has-text-weight-bold" v-if="highlights.price">{{ `$${value.maxPrice[0]} - $${value.maxPrice[1]}` }}</span>
                <ResetFilterButton v-if="highlights.price" @reset="resetFilter('maxPrice')" />
              </b-button>
            </div>
            <div ref="priceCBs" class="filterBox popper-popup">
              <FilterBoxHeader filter-name="Price Per Day" @closeFilterBox="forceClose_closeDropdownBox"/>
              <div class="ml-3 mr-3">
                <b-field v-if="priceRange.length" :label="'Price:          $'+ value.maxPrice[0] + '-$' + value.maxPrice[1]" style="width: 180px">
                  <HistogramSliderW2 data-test="price_filter_slider" v-model="priceRange" :expo="true" :sliderData="sliderData" @input="priceFilterUpdate" :width="180" :height="25" />
                </b-field>
              </div>
            </div>
          </section>
          <!-- POLICY -->
          <section>
            <div ref="minPolicy">
              <b-button
                  data-test="policy_filter_button"
                  rounded
                  size="is-small"
                  :icon-right="!value.minPolicy ? 'menu-down' : null"
                  :type="value.minPolicy ? 'is-info is-light' : 'is-outlined'"
                  @click="$popper.togglePopper($refs.minPolicy, $refs.policyCBs)"
              >
                Policy{{ value.minPolicy ? ':' : '' }} <span class="has-text-weight-bold">{{ returnPolicyValues(value.minPolicy) }}</span>
                <ResetFilterButton v-if="value.minPolicy" @reset="resetFilter('minPolicy')" />
              </b-button>
            </div>
            <div ref="policyCBs" class="filterBox popper-popup">
              <FilterBoxHeader filter-name="Min Policy" @closeFilterBox="forceClose_closeDropdownBox"/>
              <PolicySelectionCheckboxes data-test="policy_filter_list" :value="value.minPolicy" :availablePolicies="availablePolicies" @input="handlePolicyInput" />
            </div>
          </section>
          <!-- CHAIN -->
          <section>
            <div ref="selectedProvidersButton">
              <b-button
                  data-test="chains_filter_button"
                  rounded
                  size="is-small"
                  :icon-right="value.selectedProviders.length === 0 ? 'menu-down' : null"
                  :type="value.selectedProviders.length > 0 ? 'is-info is-light' : 'is-outlined'"
                  @click="$popper.togglePopper($refs.selectedProvidersButton, $refs.selectedProvidersCBs)"
              >
                Chain{{ value.selectedProviders.length > 0 ? ':' : '' }} <span class="has-text-weight-bold">{{ value.selectedProviders.map( chain => chain ).join(', ') }}</span>
                <ResetFilterButton v-if="value.selectedProviders.length > 0" @reset="resetFilter('selectedProviders')" />
              </b-button>
            </div>
            <div ref="selectedProvidersCBs" class="filterBox popper-popup">
              <FilterBoxHeader filter-name="Chain (Provider)" @closeFilterBox="forceClose_closeDropdownBox"/>
              <ChainSelection
                  data-test="chains_filter_list"
                  :selectedChains="value.selectedProviders"
                  :availableChains="availableChains"
                  :filteredChains="filteredChains"
                  :vendorsList="vendorsCars"
                  @input="handleChainInput" />
            </div>
          </section>
          <!-- VEHICLE TYPE -->
          <section>
            <div ref="selectedTypesButton">
              <b-button
                  data-test="type_filter_button"
                  rounded
                  size="is-small"
                  :icon-right="value.selectedTypes.length === 0 ? 'menu-down' : null"
                  :type="value.selectedTypes.length > 0 ? 'is-info is-light' : 'is-outlined'"
                  @click="$popper.togglePopper($refs.selectedTypesButton, $refs.selectedTypesCBs)"
              >
                Type{{ value.selectedTypes.length > 0 ? ':' : '' }} <span class="has-text-weight-bold">{{ value.selectedTypes.map( type => type ).join(', ') }}</span>
                <ResetFilterButton v-if="value.selectedTypes.length > 0" @reset="resetFilter('selectedTypes')" />
              </b-button>
            </div>
            <div ref="selectedTypesCBs" class="filterBox popper-popup">
              <FilterBoxHeader filter-name="Vehicle Type" @closeFilterBox="forceClose_closeDropdownBox"/>
              <ChainSelection
                  data-test="type_filter_list"
                  :selectedChains="value.selectedTypes"
                  :availableChains="availableTypes"
                  :filteredChains="filteredTypes"
                  @input="handleTypeInput" />
            </div>
          </section>
          <!-- VEHICLE SIZE -->
          <section>
            <div ref="selectedCategoriesButton">
              <b-button
                  data-test="size_filter_button"
                  rounded
                  size="is-small"
                  :icon-right="value.selectedCategories.length === 0 ? 'menu-down' : null"
                  :type="value.selectedCategories.length > 0 ? 'is-info is-light' : 'is-outlined'"
                  @click="$popper.togglePopper($refs.selectedCategoriesButton, $refs.selectedCategoriesCBs)"
              >
                Size{{ value.selectedCategories.length > 0 ? ':' : '' }} <span class="has-text-weight-bold">{{ value.selectedCategories.map( size => size ).join(', ') }}</span>
                <ResetFilterButton v-if="value.selectedCategories.length > 0" @reset="resetFilter('selectedCategories')" />
              </b-button>
            </div>
            <div ref="selectedCategoriesCBs" class="filterBox popper-popup">
              <FilterBoxHeader filter-name="Vehicle Size" @closeFilterBox="forceClose_closeDropdownBox"/>
              <ChainSelection
                  data-test="size_filter_list"
                  :selectedChains="value.selectedCategories"
                  :availableChains="availableCategories"
                  :filteredChains="filteredCategories"
                  @input="handleCategoryInput" />
            </div>
          </section>
        </div>

      </div>
    </div>

    <ResetAllFiltersButton v-if="numOfFiltersUsed > 2" @clicked="forceClose_closeDropdownBox(); $emit('clearFilters')"/>

  </div>
</template>

<script>
  import SortButtons from "./SortButtons";
  import HistogramSliderW2 from '../HistogramSlider/HistogramSliderW2.vue';
  import PolicySelectionCheckboxes from "./PolicySelectionCheckboxes";
  import ChainSelection from './ChainSelection.vue';
  import ToggleMapViewForBookingResults from "../BookTravel/ToggleMapViewForBookingResults";
  import bookingMixin from "../../mixins/bookingMixin";

  import ResetAllFiltersButton from "./ResetAllFiltersButton";
  import ShowModalButton from "../UI/ShowModalButton";
  import ResetFilterButton from "./ResetFilterButton";
  import FieldsetBox from "../UI/FieldsetBox";
  import FilterBoxHeader from "./FilterBoxHeader";

  export default {
    name: 'CarFiltersDropdowns',
    mixins: [bookingMixin],
    components: {
      SortButtons,
      HistogramSliderW2,
      PolicySelectionCheckboxes,
      ChainSelection,
      ToggleMapViewForBookingResults,

      ResetAllFiltersButton,
      ShowModalButton,
      ResetFilterButton,
      FieldsetBox,
      FilterBoxHeader,
      },
    data() {
        return {
          highlightedFilters: this.highlights,
        }
      },
    props: {
      formData: Object,
      availableChains: Array,
      filteredChains: Array,
      availableCategories: Array,
      filteredCategories: Array,
      value: Object,
      mapView: Boolean,
      vendorsCars: Object,
      tripVal: String,
      priceRange: Array,
      sliderData: Array,
      availablePolicies: Object,
      highestRating: Number,
      availableTypes: Array,
      filteredTypes: Array,
      highlights: Object,
      originalPriceRange: Array,
      preferredChains: Array,
      sortOptions: Array
      },
    methods: {
      handleChainInput (val) {
        if(val=='Preferred Vendors Only')
         this.value.selectedProviders = this.preferredChains;
        else 
        this.value.selectedProviders = val;

        this.$emit('input', this.value)
      },
      handleCategoryInput (val) {
        this.value.selectedCategories = val
        this.$emit('input', this.value)
      },
      handleSortInput (val) {
        this.value.sortOrder = val
        this.$emit('input', this.value)
      },
      handleTypeInput (val) {
        this.value.selectedTypes = val
        this.$emit('input', this.value)
      },
      handlePolicyInput (val) {
        this.value.minPolicy = val
        this.$emit('input', this.value)
      },
      handleRatingInput (val) {
        this.value.minRating = val
        this.$emit('input', this.value)
      },
      priceFilterUpdate(val){
        if (this.value.maxPrice[0] != val[0] || this.value.maxPrice[1] != val[1]){
          this.value.maxPrice = val
          this.$emit('input', this.value)
        }

      },
      resetFilter(filterType){
        this.filterTypeToReset = filterType;
        this.$emit('resetFilter', this.filterTypeToReset);
        this.forceKey_forceKeyChange();
        this.forceClose_closeDropdownBox();
      },
    },
    computed: {

      numOfFiltersUsed(){
          let num = 0;
          for(let highlight in this.highlights){
            if(this.highlights[highlight] === true){
              num++;
            }
          }
          return num;
        },
      sameDropoff(){
        return !this.formData.advancedSettings.diffDropLoc;
      },
    },
    mounted() {

    }
  }
</script>

<style lang="scss" scoped>
  .dropdown + .dropdown {
    margin-left: 0 !important;
  }
  .field{
    min-width: 130px;
  }
</style>
